import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme.js';
import { connect } from 'react-redux';

import { request, guid, mapStateToProps, mapDispatchToProps } from '../../utils';
import { updateSearchQuery, fetchSearchResults } from '../../actions/search';

import Body from '../../components/Body';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ArticleSummary from '../../components/ArticleSummary';
import SearchField from '../../components/SearchField';
import ContentContainer from '../../components/ContentContainer';

const SEARCH_ICON = require('../../components/SearchOverlay/search.svg');
const CLOSE_ICON = require('../../components/SearchOverlay/close.svg');

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: props.match.id
    };
  }

  updateSearchQuery(query) {
    this.props.dispatch(updateSearchQuery(query));

    if(this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = setTimeout(() => {
      const latestGuid = guid();
      this.setState({
        latest_guid: latestGuid
      });

      this.props.dispatch(fetchSearchResults(query, latestGuid)).then((response) => {
        if(response.data.guid == this.state.latest_guid && response.data.posts) {
          this.props.dispatch({
            type: "REPLACE_SEARCH_RESULTS",
            payload: response.data.posts
          });
        }
      });
    }, 200);
  }

  _setSearchQuery(key, query) {
    this.updateSearchQuery(query);
  }

  render() {
    return (
      <Body
        title="Search results - Sniffers"
        player={this.props.player}
        history={this.props.history}
        search={this.props.search} 
        dispatch={this.props.dispatch}>
        <Header content={this.props.content} dispatch={this.props.dispatch} />
        <ContentContainer>
          <div className={css(styles.content_container)}>
            <div className={css(styles.search_container)}>
              <img src={SEARCH_ICON} className={css(styles.search_icon)} />
              <div className={css(styles.search_input_container)}>
                <SearchField
                  color={Theme.black}
                  value={this.props.search.query}
                  handler={this._setSearchQuery.bind(this)} />
              </div>
            </div>
            <div className={css(styles.num_results)}>
              <div className={css(styles.num_results_text)}>{this.props.search.results.length} results found</div>
            </div>
            <div className={css(styles.articles_container)}>
              { this.props.search.results.map((post) => (
                <ArticleSummary
                  key={`${post.id}_${post.slug}`}
                  post={post} />
              ))}
            </div>
          </div>
        </ContentContainer>
        <Footer />
      </Body>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);

const styles = StyleSheet.create({
  content_container: {
    width: Theme.container_width - (Theme.margin_width * 2),
    margin: '40px auto 0px',
    paddingTop: 20,
    paddingBottom: 20,
    flexDirection: 'column',
    [Theme.mobile_query]: {
      width: '90%',
    },
  },
  search_container: {
    display: 'flex',
    marginRight: 30,
    borderBottom: `1px solid ${Theme.grey}`,
    alignItems: 'center',
  },
  search_icon_container: {
    flex: 1,
  },
  search_icon: {
    marginRight: 30,
    marginBottom: 10,
  },
  'search_input_container': {
    flex: 9,
  },
  articles_container: {
    paddingTop: 30,
    paddingBottom: 100,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: "wrap"
  },
  num_results: {
    display: 'block',
    marginTop: 30,
  },
  num_results_text: {
    fontFamily: Theme.fontFamily,
    color: Theme.dark_grey,
    fontSize: 10,
    letterSpacing: 2,
    textTransform: 'uppercase',
  },
});



// WEBPACK FOOTER //
// ./src/views/Search/index.js